import React from 'react';
import CheckList from '../../../../Elements/CheckList';
import CheckListToneEnum from '../../../../Enums/CheckListToneEnum';
import InvoiceAutomationJobId from './InvoiceAutomationJobId';
import InvoiceAutomationInvoiceId from './InvoiceAutomationInvoiceId';

// The jobs a run takes, or took, off its drafts because they no longer pass the Ready for Invoicing rules, each with
// the draft it is on and why, as Run Now's preview and result list them; jobs are { tpJobId, thirdPartyJobId,
// tpClientInvoiceId, reason }. Nothing when there are none.
export default function InvoiceAutomationRemovedJobs({ title = '', lead = null, jobs = [] }) {
  if (jobs.length === 0) {
    return null;
  }

  const items = jobs.map((job) => ({
    tone: CheckListToneEnum.Warn,
    text: (
      <>
        Job{' '}
        <InvoiceAutomationJobId
          tpJobId={job.tpJobId}
          thirdPartyJobId={job.thirdPartyJobId}
        />{' '}
        on draft <InvoiceAutomationInvoiceId tpClientInvoiceId={job.tpClientInvoiceId} />: {job.reason}
      </>
    ),
  }));
  return (
    <section className='iauto-run-section'>
      <h4>{title}</h4>
      {lead && <p>{lead}</p>}
      <CheckList items={items} />
    </section>
  );
}
